export enum SettingsRoutes {
    interestRate = 'interest-rate',
    applicationLicense = 'application-license',
    landingPage = 'landing-page',
    scoringModel = 'scoring-model',
    documentTemplates = 'document-templates',
    notificationTemplates = 'notification-templates',
}

export const ListApplicationSettings = [
    {
        id: 1,
        settingItemId: SettingsRoutes.interestRate,
        name: 'Interest rate',
    },
    {
        id: 2,
        settingItemId: SettingsRoutes.applicationLicense,
        name: 'License key',
    },
    {
        id: 3,
        settingItemId: SettingsRoutes.landingPage,
        name: 'Landing page',
    },
    {
        id: 4,
        settingItemId: SettingsRoutes.scoringModel,
        name: 'Scoring model',
    },
    {
        id: 5,
        settingItemId: SettingsRoutes.documentTemplates,
        name: 'Document templates',
    },
    {
        id: 6,
        settingItemId: SettingsRoutes.notificationTemplates,
        name: 'Notification templates',
    },
];
